import React, { useState, useEffect } from "react";
import { Grid, TextField, Box, Button,Typography } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
const ConsentForm = (props) => {
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const [formData, setFormData] = useState({
    signature: "",
    date: "",
    printName: "",
  });
  const [SignatureDate, setSignatureDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [Signature, setSignature] = useState("");
  const [PrintName, setPrintName] = useState("");
  const FormId = props.FormId;
  useEffect(() => {
    if (FormId) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientForms/GetFormInformedConsentId?id=${FormId}`,
          { headers }
        )
        .then((response) => {
          // setSignatureDate(moment(response.signatureDate).format("MM-DD-YYYY"));
          setSignatureDate(
            response.signatureDate
              ? moment(response.signatureDate).format("YYYY-MM-DD")
              : ""
          );
          setSignature(response.patientSignature);
          setPrintName(response.patientName);
          // setFormData((prev) => ({
          //     ...prev,
          //     signature: response.patientSignature,
          //     printName: response.patientName,
          //     date: response.signatureDate
          //       ? moment(response.signatureDate).format("MM-DD-YYYY")
          //       : "",
          //   }));
        })
        .catch((error) => {});
    }
  }, [FormId]);

  const handleSubmit = async () => {
    const postData = {
      id: props.FormId,
      patientName: props.PatientName,
      patientId: props.PatientId,
      patientSignature: Signature,
      signatureDate: SignatureDate,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddFormInformedConsent`,
        postData,
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Form Added!",
         html: `<p>Informed Consent Form has been saved successfully.</p>`,
        confirmButtonColor: "#2196F3",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
      if (props.onFormSubmit) {
        props.onFormSubmit(response); // send full response or response.data.id
      }

      props.handleClose();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        html: `<p>${
          error.response?.data?.message ||
          "Something went wrong. Please try again."
        }</p>`,
        confirmButtonColor: "#F44336",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
    }
  };
  return (
    <Grid
      container
      columnSpacing={1}
      style={{ color: "black", marginTop: "20px" }}
    >
     <Grid container spacing={3} >
             <Grid item xs={12}>
               <Typography
                 variant="h4"
                 align="center"
                 fontWeight="bold"
                 color="primary"
                 gutterBottom
               >
                  INFORMED CONSENT
               </Typography>
               
             </Grid>
           </Grid>
      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        <Grid item xs={12} style={{ marginTop: "10px" }}>
          <h3 style={{ fontWeight: "bold" }}>
            Informed Consent for the Treatment of Sleep-Related Breathing
            Disorders
          </h3>
        </Grid>

        <Grid item xs={12} style={{ marginTop: "20px" }}>
          <h6>
            You have been diagnosed by your physician as requiring treatment for
            a sleep-related breathing disorder, such as snoring and/or
            obstructive sleep apnea (OSA). OSA may pose serious health risks
            since it disrupts normal sleep patterns and can reduce normal blood
            oxygen levels. This condition can increase a person’s risk for
            excessive daytime sleepiness, driving and work-related accidents,
            high blood pressure, heart disease, stroke, diabetes, obesity,
            memory and learning problems, and depression.
          </h6>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        <Grid item xs={11} style={{ marginTop: "20px" }}>
          <h5 style={{ fontWeight: "bold" }}>
            What is Oral Appliance Therapy?
          </h5>
        </Grid>

        <Grid item xs={11} style={{ marginTop: "20px" }}>
          <h6>
            Oral appliance therapy for snoring and/or OSA attempts to assist
            breathing by keeping the tongue and jaw in a forward position during
            sleeping hours. OAT has effectively treated many patients. However,
            there are no guarantees that it will be effective for you. Every
            patient’s case is different and there are many factors that
            influence the upper airway during sleep. It is important to
            recognize that even when the therapy is effective, there may be a
            period of time before the appliance functions maximally.During this
            time, you may still experience symptoms related to your
            sleep-related breathing disorder.
            <br />
            <br />A post-adjustment polysomnogram (sleep study) is necessary to
            objectively assure effective treatment. This must be obtained from
            your physician.
          </h6>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        <Grid item xs={11} style={{ marginTop: "25px" }}>
          <h5 style={{ fontWeight: "bold" }}>
            Side-Effects and Complications of Oral Appliance Therapy
          </h5>
        </Grid>

        <Grid item xs={11} style={{ marginTop: "10px" }}>
          <h6>
            Published studies show that short-term side effects of oral
            appliance therapy may include excessive salivation, difficulty
            swallowing (with the appliance in place), sore jaws or teeth, jaw
            joint pain, dry mouth, gum pain, loosening of teeth, and short-term
            bite changes. There are also reports of dislodgement of ill-fitting
            dental restorations. Most of these side effects are minor and
            resolve quickly on their own or with minor adjustments of the
            appliance.
            <br />
            <br />
            Long-term complications include bite changes that may be permanent
            resulting from tooth movement or jaw joint repositioning. These
            complications may or may not be fully reversible once oral appliance
            therapy is discontinued. If not reversible, restorative treatment or
            orthodontic intervention may be required for which you will be
            responsible.
            <br />
            <br />
            Follow-up visits with the provider of your oral appliance are
            mandatory to ensure proper fit and healthy condition. If unusual
            symptoms or discomfort occur that fall outside the scope of this
            consent, or if pain medication is required to control discomfort, it
            is recommended that you cease using the appliance until you are
            evaluated further. As this office cannot ensure the success of any
            type of therapy and cannot guarantee that any patient will comply
            with the treatment for sleep apnea, I hereby waive any rights that
            I, my heirs, and my assigns might have to seek legal redress for any
            damage, physical or monetary, that I might sustain as a result of my
            treatment for sleep apnea or any failure on my part to comply with
            treatment.
          </h6>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        <Grid item xs={11} style={{ marginTop: "30px" }}>
          <h5 style={{ fontWeight: "bold" }}>
            Alternative Treatments for Sleep-Related Breathing Disorders
          </h5>
        </Grid>

        <Grid item xs={11} style={{ marginTop: "20px" }}>
          <h6>
            Other accepted treatments for sleep-related breathing disorders
            include behavioral modification, Continuous Positive Airway Pressure
            (CPAP) and various surgeries. It is your decision to choose oral
            appliance therapy to treat your sleep-related breathing disorder and
            you are aware that it may not be completely effective for you. It is
            your responsibility to report the occurrence of side effects and to
            address any questions to this provider’s office. Failure to treat
            sleep-related breathing disorders may increase the likelihood of
            significant medical complications.
            <br />
            <br />
            If you understand the explanation of the proposed treatment, and
            have asked this provider any questions you may have about this form
            of treatment, please sign and date this form below. You will receive
            a copy.
          </h6>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        <Grid item xs={2} style={{ marginTop: "30px" }}>
          <h6>Signature:</h6>
        </Grid>
        <Grid item xs={4} style={{ marginTop: "20px" }}>
          <TextField
            size="small"
            variant="standard"
            name="signature"
            value={Signature}
            onChange={(e) => setSignature(e.target.value)}
            fullWidth
          />
        </Grid>

        <Grid item xs={2} style={{ marginTop: "30px" }}>
          <h6>Date:</h6>
        </Grid>
        <Grid item xs={4} style={{ marginTop: "20px" }}>
          <TextField
            type="date"
            size="small"
            variant="standard"
            value={SignatureDate}
            onChange={(e) => setSignatureDate(e.target.value)}
            fullWidth
          />
        </Grid>

        <Grid item xs={3} style={{ marginTop: "30px" }}>
          <h6>Print Name:</h6>
        </Grid>
        <Grid item xs={9} style={{ marginTop: "20px" }}>
          <TextField
            size="small"
            variant="standard"
            name="printName"
            value={PrintName || props.PatientName}
            onChange={(e) => setPrintName(e.target.value)}
            fullWidth
          />
        </Grid>
      </Grid>

      {/* Submit Button */}
      <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
        <Button
          type="submit"
          onClick={handleSubmit}
          variant="contained"
          sx={{
            backgroundColor: "#A574FD",
            color: "white",
            minWidth: 120,
            height: 40,
            "&:hover": {
              backgroundColor: "#8A5CE6",
            },
          }}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
};

export default ConsentForm;
